import { createSelector } from '@reduxjs/toolkit';
import { GIS_SERVICES as GIS_SERVICES_CAPABILITY } from '@rsos/capstone/src/constants/capabilities';
import { GIS_SERVICES as GIS_SERVICES_PERMISSION } from '@rsos/capstone/src/constants/permissionNames';

/**
 * Function to determine if the current user's authority has the `gis_services`
 * capability and permission enabled
 * @param {Object} state - redux state
 * @param {Object} state.psaps - PSAPS reducer
 * @param {Object} state.sinatra - Sinatra reducer
 */
const checkGISServicesAccess = createSelector(
  state => state,
  state => {
    const isCapabilityEnabled =
      !!state.psaps?.currentPSAP?.activeCapabilities?.[GIS_SERVICES_CAPABILITY];
    const isPermissionEnabled =
      !!state.sinatra?.user?.currentRole?.permissions?.includes(
        GIS_SERVICES_PERMISSION,
      );
    return isCapabilityEnabled && isPermissionEnabled;
  },
);

export default checkGISServicesAccess;
